import { parseAsString, useQueryState } from 'nuqs';

export function useShipmentTemplateListFilter() {
  const [search, setSearch] = useQueryState('search', parseAsString.withDefault(''));

  return {
    setSearch,
    search,
  };
}
